import { render, staticRenderFns } from "./StatutoryReportSetupEdit_new.vue?vue&type=template&id=3fad5232"
import script from "./StatutoryReportSetupEdit_new.vue?vue&type=script&lang=js"
export * from "./StatutoryReportSetupEdit_new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports